/**
 * Counts the number of groups within the given product results.
 * @param {Array} results
 * @returns {number}
 */
const countProductResults = (results) => (
    results.reduce((sum, { groups = [] }) => sum + groups.length, 0)
);

export default countProductResults;



// WEBPACK FOOTER //
// ./src/scripts/components/products/countProductResults.js